var IncompleteCampaignModel = /** @class */ (function () {
    function IncompleteCampaignModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, advertiserId = _a.advertiserId, _b = _a.advertiserName, advertiserName = _b === void 0 ? '' : _b, anLineItemId = _a.anLineItemId, _c = _a.createdTime, createdTime = _c === void 0 ? '' : _c, id = _a.id, insertionOrderId = _a.insertionOrderId, _d = _a.insertionOrderName, insertionOrderName = _d === void 0 ? '' : _d, _e = _a.menuType, menuType = _e === void 0 ? '' : _e, _f = _a.name, name = _f === void 0 ? '' : _f;
        this.advertiserId = advertiserId;
        this.advertiserName = advertiserName;
        this.anLineItemId = anLineItemId;
        this.createdTime = createdTime;
        this.id = id;
        this.insertionOrderId = insertionOrderId;
        this.insertionOrderName = insertionOrderName;
        this.menuType = menuType;
        this.name = name;
    }
    IncompleteCampaignModel.assign = function (data) {
        return new IncompleteCampaignModel(data);
    };
    return IncompleteCampaignModel;
}());
export { IncompleteCampaignModel };
